(function () {
  'use strict';

  var CLS  = 'product-pay-later-details';
  var BCLS = CLS + '__body';
  var LCLS = CLS + '__logos';
  var PP_SRC = 'https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-wordmark-color.svg';
  var bundleTimer, logoTimer;

  var SVG_SHOPPAY = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99 25" aria-label="Shop Pay" role="img"><path fill="currentColor" d="M70.842 7.915h2.25c1.561 0 2.328.642 2.328 1.715 0 1.074-.739 1.715-2.259 1.715h-2.32v-3.43ZM80.525 16.142c-.879 0-1.227-.474-1.227-.948 0-.642.725-.935 2.147-1.102l1.115-.125c-.07 1.227-.892 2.175-2.035 2.175Z"/><path fill="currentColor" fill-rule="evenodd" d="M65.645.5a3.64 3.64 0 0 0-3.64 3.64V20.7a3.64 3.64 0 0 0 3.64 3.64h29.668a3.64 3.64 0 0 0 3.64-3.64V4.14A3.64 3.64 0 0 0 95.314.5H65.645Zm5.197 16.674v-4.197h2.64c2.412 0 3.695-1.353 3.695-3.402 0-2.05-1.283-3.277-3.695-3.277h-4.341v10.876h1.7Zm9.334.223c1.297 0 2.147-.572 2.538-1.548.112 1.088.767 1.645 2.189 1.269l.014-1.157c-.572.055-.683-.154-.683-.753v-2.845c0-1.673-1.102-2.663-3.138-2.663-2.008 0-3.165 1.004-3.165 2.705h1.562c0-.809.572-1.297 1.576-1.297 1.06 0 1.547.46 1.534 1.255v.363l-1.8.195c-2.021.223-3.137.99-3.137 2.329 0 1.101.781 2.147 2.51 2.147Zm9.906.32c-.711 1.73-1.855 2.245-3.64 2.245h-.766V18.54h.822c.977 0 1.45-.307 1.966-1.185L85.3 9.923h1.757l2.259 5.424 2.008-5.424h1.715l-2.956 7.795Z" clip-rule="evenodd"/><path fill="currentColor" d="M6.992 11.055c-2.359-.509-3.41-.708-3.41-1.612 0-.85.711-1.274 2.134-1.274 1.25 0 2.165.544 2.839 1.61.05.081.155.11.241.066l2.655-1.335a.186.186 0 0 0 .076-.259c-1.102-1.9-3.137-2.94-5.818-2.94C2.188 5.311 0 7.037 0 9.781c0 2.915 2.664 3.651 5.027 4.16 2.362.51 3.417.709 3.417 1.613s-.769 1.33-2.303 1.33c-1.416 0-2.467-.644-3.102-1.896a.186.186 0 0 0-.251-.082L.14 16.21a.188.188 0 0 0-.083.253c1.051 2.102 3.207 3.285 6.087 3.285 3.668 0 5.885-1.698 5.885-4.527 0-2.83-2.677-3.651-5.037-4.16v-.007ZM21.218 5.311c-1.505 0-2.835.531-3.791 1.477-.06.057-.159.015-.159-.067V.687A.185.185 0 0 0 17.081.5h-3.322a.185.185 0 0 0-.187.187v18.73c0 .104.083.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-1.587 1.223-2.804 2.87-2.804 1.649 0 2.843 1.191 2.843 2.804v8.216c0 .104.082.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-3.452-2.274-5.89-5.459-5.89ZM33.415 4.774c-1.803 0-3.493.55-4.706 1.343a.186.186 0 0 0-.06.25l1.464 2.488c.054.089.168.12.257.066a5.853 5.853 0 0 1 3.052-.834c2.899 0 5.03 2.036 5.03 4.726 0 2.292-1.706 3.99-3.868 3.99-1.762 0-2.985-1.022-2.985-2.463 0-.825.352-1.502 1.27-1.98a.183.183 0 0 0 .073-.258l-1.381-2.327a.187.187 0 0 0-.226-.079c-1.85.683-3.15 2.327-3.15 4.533 0 3.338 2.67 5.83 6.396 5.83 4.35 0 7.478-3 7.478-7.303 0-4.612-3.64-7.982-8.644-7.982ZM51.776 5.283c-1.68 0-3.182.62-4.277 1.707a.093.093 0 0 1-.16-.066v-1.31a.185.185 0 0 0-.187-.186h-3.235a.185.185 0 0 0-.188.187v18.702c0 .104.083.186.188.186h3.32a.185.185 0 0 0 .188-.186v-6.133c0-.082.099-.123.16-.07 1.091 1.012 2.536 1.603 4.19 1.603 3.897 0 6.936-3.139 6.936-7.217 0-4.078-3.042-7.217-6.935-7.217Zm-.63 11.266c-2.215 0-3.895-1.754-3.895-4.074S48.928 8.4 51.147 8.4c2.22 0 3.893 1.726 3.893 4.075 0 2.348-1.651 4.074-3.896 4.074h.003Z"/></svg>';

  var SVG_KLARNA = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 71.25 30" aria-label="Klarna" role="img"><g clip-path="url(#klarna-logo-clip)"><path fill="#FFA8CD" d="M62.7688 0H8.48123C3.79718 0 0 3.79718 0 8.48123V21.5188C0 26.2028 3.79718 30 8.48123 30H62.7688c4.684 0 8.4812-3.7972 8.4812-8.4812V8.48123C71.25 3.79718 67.4528 0 62.7688 0Z"/><path fill="#0B051D" d="M57.412 19.1418c-1.2436 0-2.2134-1.0286-2.2134-2.2776 0-1.2491.9698-2.2776 2.2134-2.2776 1.2441 0 2.2135 1.0285 2.2135 2.2776 0 1.249-.9694 2.2776-2.2135 2.2776Zm-.6215 2.4062c1.0608 0 2.4145-.4041 3.1645-1.9837l.0731.0367c-.329.8633-.329 1.3776-.329 1.5062v.202h2.6704v-8.8901h-2.6704v.2021c0 .1286 0 .6428.329 1.5061l-.0731.0368c-.75-1.5797-2.1037-1.9838-3.1645-1.9838-2.543 0-4.3355 2.0205-4.3355 4.6839 0 2.6633 1.7925 4.6838 4.3355 4.6838Zm-8.9822-9.3677c-1.2073 0-2.1586.4225-2.9268 1.9838l-.0732-.0368c.3292-.8633.3292-1.3775.3292-1.5061v-.2021h-2.6708v8.8901h2.744v-4.6838c0-1.2307.7134-2.0021 1.8659-2.0021 1.1526 0 1.7193.6612 1.7193 1.9837v4.7022H51.54v-5.6573c0-2.0205-1.5731-3.4716-3.7317-3.4716Zm-9.3112 1.9838-.0731-.0368c.3293-.8633.3293-1.3775.3293-1.5061v-.2021h-2.6708v8.8901h2.7439l.0183-4.2797c0-1.249.6586-2.0021 1.7379-2.0021.2926 0 .5305.0367.8048.1102v-2.7185c-1.2073-.2571-2.2866.2021-2.8903 1.745Zm-8.7257 4.9777c-1.244 0-2.2135-1.0286-2.2135-2.2776 0-1.2491.9695-2.2776 2.2135-2.2776 1.2439 0 2.2134 1.0285 2.2134 2.2776 0 1.249-.9695 2.2776-2.2134 2.2776Zm-.622 2.4062c1.061 0 2.4147-.4041 3.1647-1.9837l.0732.0367c-.3293.8633-.3293 1.3776-.3293 1.5062v.202h2.6708v-8.8901H32.058v.2021c0 .1286 0 .6428.3293 1.5061l-.0732.0368c-.75-1.5797-2.1037-1.9838-3.1647-1.9838-2.5428 0-4.3355 2.0205-4.3355 4.6839 0 2.6633 1.7927 4.6838 4.3355 4.6838Zm-8.1588-.2388h2.744V8.45166h-2.744V21.3092ZM18.9784 8.45166h-2.7988c0 2.29594-1.4086 4.35314-3.5489 5.82264l-.8415.5878V8.45166H8.88062V21.3092h2.90858v-6.3736l4.8111 6.3736h3.5489L15.521 15.211c2.1037-1.5245 3.4757-3.894 3.4574-6.75934Z"/></g><defs><clipPath id="klarna-logo-clip"><path fill="#fff" d="M0 0h71.25v30H0z"/></clipPath></defs></svg>';

  var SVG_CLEARPAY = '<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" viewBox="0 0 102 21" aria-label="Clearpay" role="img"><path fill="#b2fce4" d="M89.85 20.92h-78.9a10.42 10.42 0 110-20.82h78.89a10.42 10.42 0 010 20.83v-.01z"/><g><path d="M72.05 6.76l-5.13 10.57H64.8l1.91-3.95-3-6.62h2.18l1.93 4.44 2.11-4.44h2.12z"/><path d="M52.55 10.52c0-1.22-.92-2.15-2.04-2.15-1.13 0-2.04.9-2.04 2.15 0 1.23.91 2.14 2.04 2.14 1.12 0 2.04-.93 2.04-2.14m-5.94 6.81V6.76h1.84v.98a2.98 2.98 0 012.37-1.12c2.03 0 3.62 1.67 3.62 3.88 0 2.2-1.62 3.88-3.67 3.88a2.9 2.9 0 01-2.26-1v3.95h-1.9z"/><path d="M61.1 10.52c0-1.27-.92-2.15-2.04-2.15-1.13 0-2.04.9-2.04 2.15 0 1.23.91 2.14 2.04 2.14 1.12 0 2.04-.89 2.04-2.14m.01 3.75v-.97a3 3 0 01-2.37 1.09c-2.06 0-3.62-1.65-3.62-3.87 0-2.2 1.62-3.89 3.67-3.89a3 3 0 012.32 1.08v-.95h1.85v7.5H61.1z"/><path d="M43.28 7.5s.46-.88 1.62-.88c.5 0 .8.17.8.17v1.92s-.69-.43-1.33-.34c-.63.09-1.04.67-1.04 1.45v4.45h-1.9v-7.5h1.84v.73z"/><path d="M86.37 6.34L84.2 5.09l-2.22-1.27a2.2 2.2 0 00-3.3 1.9v.3c0 .15.09.3.22.37l1.03.59c.29.16.64-.05.64-.37v-.68c0-.34.36-.54.65-.38l2.02 1.16 2.02 1.16c.3.16.3.59 0 .75l-2.02 1.16-2.02 1.16a.44.44 0 01-.65-.38v-.33a2.2 2.2 0 00-3.3-1.91l-2.21 1.27-2.19 1.25a2.2 2.2 0 000 3.82l2.19 1.25 2.21 1.27a2.2 2.2 0 003.3-1.9v-.3c0-.15-.08-.3-.22-.37l-1.03-.59a.43.43 0 00-.64.37v.68c0 .34-.36.54-.65.38L76 14.29 74 13.13a.43.43 0 010-.75L76 11.22l2.02-1.16c.3-.16.65.05.65.38v.33a2.2 2.2 0 003.3 1.91l2.22-1.27 2.18-1.25a2.2 2.2 0 000-3.82z"/><path d="M20.22 11.47a3.77 3.77 0 01-3.81 2.91 3.8 3.8 0 01-3.89-3.87c0-2.2 1.7-3.89 3.92-3.89A3.78 3.78 0 0120.2 9.5h-1.95a2.04 2.04 0 00-1.8-1.12c-1.11 0-2.04.92-2.04 2.13s.93 2.13 2.04 2.13c.8 0 1.49-.45 1.81-1.17h1.96z"/><path d="M21.1 14.26V3.67h1.88v10.6H21.1z"/><path d="M25.83 11a1.86 1.86 0 001.93 1.75c.8 0 1.4-.38 1.77-.98h1.93c-.45 1.6-1.87 2.61-3.75 2.61-2.27 0-3.85-1.59-3.85-3.85s1.68-3.9 3.9-3.9a3.75 3.75 0 013.8 4.38h-5.73zm3.76-1.17c-.13-.97-.93-1.56-1.86-1.56-.92 0-1.69.57-1.88 1.56h3.74z"/><path d="M38.35 14.26v-.97a3 3 0 01-2.36 1.1c-2.06 0-3.62-1.66-3.62-3.88 0-2.2 1.62-3.89 3.66-3.89.96 0 1.77.42 2.32 1.08v-.94h1.85v7.5h-1.85zm-.01-3.75c0-1.26-.92-2.15-2.05-2.15-1.12 0-2.04.9-2.04 2.15 0 1.23.92 2.15 2.04 2.15 1.13 0 2.05-.89 2.05-2.15z"/></g></svg>';

  var bundleTimer, logoTimer;

  function qs(el, sel) { return el && el.querySelector(sel); }

  function svgNode(str) {
    var d = document.createElement('div');
    d.innerHTML = str;
    return d.firstElementChild;
  }

  function syncLogos(details) {
    var body = qs(details, '.' + BCLS);
    var row  = qs(details, '.' + LCLS);
    if (!body || !row) return;

    var frag = document.createDocumentFragment();

    if (qs(body, '[id^="paypal-upstream"],[data-pp-message]')) {
      var pp = document.createElement('img');
      pp.src = PP_SRC;
      pp.alt = '';
      pp.setAttribute('role', 'presentation');
      pp.setAttribute('class', CLS + '__logo ' + CLS + '__logo--paypal');
      frag.appendChild(pp);
    }

    if (qs(body, 'shopify-payment-terms')) {
      var s = svgNode(SVG_SHOPPAY);
      if (s) {
        s.setAttribute('class', CLS + '__logo ' + CLS + '__logo--shoppay');
        s.style.color = '#5a31f4';
        frag.appendChild(s);
      }
    }

    if (qs(body, 'klarna-placement')) {
      var k = svgNode(SVG_KLARNA);
      if (k) {
        k.setAttribute('class', CLS + '__logo ' + CLS + '__logo--klarna');
        frag.appendChild(k);
      }
    }

    if (qs(body, 'square-placement')) {
      var c = svgNode(SVG_CLEARPAY);
      if (c) {
        c.setAttribute('class', CLS + '__logo ' + CLS + '__logo--clearpay');
        frag.appendChild(c);
      }
    }

    if (frag.childNodes.length > row.children.length) {
      row.innerHTML = '';
      row.appendChild(frag);
    }
  }

  function scheduleLogo(details) {
    clearTimeout(logoTimer);
    var attempt = 0;
    var delays = [0, 600, 1800, 4000];

    function trySync() {
      syncLogos(details);
      var row = qs(details, '.' + LCLS);
      attempt++;
      if (attempt < delays.length && row && row.children.length < 2) {
        logoTimer = setTimeout(trySync, delays[attempt]);
      }
    }

    trySync();

    var body = qs(details, '.' + BCLS);
    if (body && !body._plLogoObs) {
      body._plLogoObs = true;
      new MutationObserver(function () {
        clearTimeout(logoTimer);
        logoTimer = setTimeout(function () { syncLogos(details); }, 80);
      }).observe(body, { childList: true, subtree: true });
    }
  }

  function buildDetails(priceBlk) {
    var next = priceBlk.nextElementSibling;
    if (next && next.classList && next.classList.contains(CLS)) return next;

    var details = document.createElement('details');
    details.className = CLS;

    var summary = document.createElement('summary');
    summary.className = CLS + '__summary';
    summary.innerHTML =
      '<span class="' + CLS + '__title">Pay later options available' +
        '<svg class="' + CLS + '__chev" xmlns="http://www.w3.org/2000/svg" ' +
          'width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
          'stroke="currentColor" stroke-width="2.5" aria-hidden="true">' +
          '<polyline points="6 9 12 15 18 9"></polyline></svg>' +
      '</span>' +
      '<span class="' + LCLS + '" aria-hidden="true"></span>';

    var body = document.createElement('div');
    body.className = BCLS;

    details.appendChild(summary);
    details.appendChild(body);
    priceBlk.insertAdjacentElement('afterend', details);
    return details;
  }

  function collectAppBlocks(priceBlk) {
    var out = [], el = priceBlk.nextElementSibling;
    while (el && el.classList) {
      if (el.classList.contains(CLS)) break;
      if (!el.classList.contains('product-block__@app')) break;
      if (qs(el, 'klarna-placement,square-placement')) out.push(el);
      el = el.nextElementSibling;
    }
    return out;
  }

  function bundle() {
    var mp = document.querySelector('.main-product');
    if (!mp) return;

    var priceEl = qs(mp, '[id^="price-"]');
    var pb = priceEl && priceEl.closest('.product-block__price');
    if (!pb) return;

    var paypal      = qs(priceEl, '[id^="paypal-upstream"],[data-pp-message]') ||
                      qs(pb, '[id^="paypal-upstream"],[data-pp-message]');
    var installment = qs(pb, 'form.installment');
    var appBlocks   = collectAppBlocks(pb);

    var details = buildDetails(pb);
    var body    = qs(details, '.' + BCLS);
    if (!body) return;

    if (!installment) installment = qs(body, 'form.installment');

    if (!paypal && !installment && !appBlocks.length) {
      if (!body.children.length) details.remove();
      return;
    }

    if (paypal      && !body.contains(paypal))      body.appendChild(paypal);
    if (installment && !body.contains(installment)) body.appendChild(installment);
    for (var i = 0; i < appBlocks.length; i++) {
      if (!body.contains(appBlocks[i])) body.appendChild(appBlocks[i]);
    }

    scheduleLogo(details);
  }

  function runBundle() {
    clearTimeout(bundleTimer);
    bundleTimer = setTimeout(bundle, 80);
  }

  function init() {
    bundle();

    var mp = document.querySelector('.main-product');
    if (!mp || mp._plInit) return;
    mp._plInit = true;

    var priceEl = qs(mp, '[id^="price-"]');
    if (priceEl) {
      new MutationObserver(runBundle).observe(priceEl, { childList: true, subtree: true });
    }
    new MutationObserver(runBundle).observe(mp, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target || !ev.target.classList) return;
    if (!ev.target.classList.contains('main-product')) return;
    var freshMp = document.querySelector('.main-product');
    if (freshMp) freshMp._plInit = false;
    init();
  });

})();
